<div class="two-factor-gate">
    <div class="two-factor-gate__header">
        <div class="two-factor-gate__badge">
            <i class="fa fa-shield" aria-hidden="true"></i>
        </div>
        <div class="two-factor-gate__title">{{ copy.title }}</div>
        <div class="two-factor-gate__subtitle">{{ copy.message }}</div>
    </div>

    <!-- Method select (cards) -->
    <ng-container *ngIf="!activeSetup">
        <div class="two-factor-gate__body">
            <app-alert-block type="info" class="two-factor-gate__recommendation">
                {{ 'For reliable access, set up both an authenticator app and SMS — that way a second method is available if you ever lose the first.' }}
            </app-alert-block>

            <app-two-factor-auth [compact]="true"
                                 [highlight2fa]="true"
                                 (setupRequested)="onSetupRequested($event)"
                                 (enrollmentChecked)="onEnrollmentChecked($event)"></app-two-factor-auth>
        </div>

        <div class="two-factor-gate__footer">
            <button *ngIf="dismissible"
                    type="button"
                    class="two-factor-gate__cancel"
                    mat-dialog-close>{{ 'Maybe later' }}</button>
            <button *ngIf="!dismissible"
                    type="button"
                    class="two-factor-gate__cancel"
                    [mat-dialog-close]="false">{{ 'Cancel' }}</button>
        </div>
    </ng-container>

    <!-- Inline setup step (single surface — no nested dialog) -->
    <app-google-auth-setup-step *ngIf="activeSetup === 'google'"
                                dismissLabel="Back"
                                (completed)="onStepCompleted()"
                                (cancelled)="onStepCancelled()"></app-google-auth-setup-step>
    <app-sms-auth-setup-step *ngIf="activeSetup === 'sms'"
                             dismissLabel="Back"
                             (completed)="onStepCompleted()"
                             (cancelled)="onStepCancelled()"></app-sms-auth-setup-step>
</div>
